import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import kz from "./locale/kz/translation.json";
import ru from "./locale/ru/translation.json";
import en from "./locale/en/translation.json";

// The old config cached the browser locale ("en-US"); keep only a kk/ru/en choice.
try {
  if (!["kk", "ru", "en"].includes(localStorage.getItem("i18nextLng"))) {
    localStorage.removeItem("i18nextLng");
  }
} catch (e) {}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // A browser's en-US says which language Windows was installed in, not
    // what the student reads: default to Kazakh, keep only an explicit choice.
    supportedLngs: ["kk", "ru", "en"],
    fallbackLng: "kk",
    detection: { order: ["querystring", "localStorage"] },
    interpolation: {
      escapeValue: false,
    },
    resources: {
      kk: kz,
      ru: ru,
      en: en,
    },
    defaultNS: "translations",
    ns: ["translations"],
  });

export default i18n;
